import { AfterViewInit, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { PixelService } from '../../services/pixel.service';

interface FooterLink {
  titleKey: string;
  fragment: string;
}

interface FooterLegal {
  titleKey: string;
  routeLink: string;
}

interface FooterSocial {
  text: string;
  link: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements AfterViewInit {
  currentLanguage = '';

  private readonly translate = inject(TranslateService);
  private readonly pixelService = inject(PixelService);

  readonly navLinks: FooterLink[] = [
    { titleKey: 'top_navigation.nav_protocol', fragment: 'protocol' },
    { titleKey: 'top_navigation.nav_analytics', fragment: 'analytics' },
    { titleKey: 'top_navigation.nav_activity', fragment: 'activity' },
    { titleKey: 'top_navigation.nav_docs', fragment: 'docs' },
    { titleKey: 'top_navigation.nav_faq', fragment: 'faq' },
  ];

  readonly legalLinks: FooterLegal[] = [
    { titleKey: 'footer_navigation.terms', routeLink: 'termsandcondition' },
    { titleKey: 'footer_navigation.privacy', routeLink: 'privacypolicy' },
    // { titleKey: 'footer_navigation.cookies', routeLink: '' },
  ];

  readonly social: FooterSocial[] = [
    { text: 'footer_navigation.telegram', link: 'https://t.me/seerdexofficial' },
    { text: 'footer_navigation.twitter', link: 'https://x.com/seerdexmarkets' },
    { text: 'footer_navigation.discord', link: 'https://discord.com/invite/ep2p9PWNk' },
    // { text: 'footer_navigation.discord', link: '' },
  ];

  constructor() {
    this.translate.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe((params: LangChangeEvent) => {
        this.currentLanguage = params.lang;
      });
  }

  trackExternalLink(url: string, name: string): void {
    this.pixelService.trackPageClick(url, name);
  }
  ngAfterViewInit(): void {
    this.currentLanguage = this.translate.getCurrentLang();
  }
}
